import QualityCheckView from 'components/organisms/quality-check/QualityCheckView'
import React from 'react'

const QualityCheck = () => {
    return (
        <QualityCheckView />
    )
}

export default QualityCheck